export default "__VITE_ASSET__c897ed62__"